import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../shared/components/loader';
import Requests from './../../../services/requests.service';
import CONSTANT from './../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Pagination from './../../../../shared/components/pagination'
import moment from 'moment';
import ClientView from '../../../../clientmanagement/views/client/clientlisting/clienteview';
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect';
export default {
  name: 'completedrequests',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    CustomExpandableTable,
    Pagination,
    ClientView,
    Multiselect
  },
  props: ['title'],
  data() {
    return {
      useremail : '',
      tableColumn: ['Company Short/Display Name','Request ID', 'Request For', 'Request By', 'Request Date','Request Status','Action Date','Action By','Action'],
      request : 'client',
      requestID : '',
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      companyName : '',
      CompanyShortNameArr : [],
      innerTableColumn : [],
      clientsystemID : '',
      fromdate : '',
      todate : '',
      currentPage: 1,
      pageCount: 0,
      pageNo: 0,
      offset: 0,
      totalrows:0,
      isLoading : false,
      viewFlag : false,
      pendingRequestsList :[],
      generalInfo : {},
      legelInfo : {},
      spocInfo : {},
      bankInfo : {},
      statelist : [],
      generalInfoBlank : 1,
      spocInfoBlank : 1,
      legelInfoBlank : 1,
      bankInfoBlak : 1,
      selectedViewRow : '',
      selectclientSystemID : '',
      selectBusinessAccId: '',
      userid : '',
      userrole : ''
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = parseInt(userdetail.userid);
    this.userrole = userdetail.rolename[0];
    this.isLoading = true;
    await Promise.all([
      this.getCompanyShortName(),
      this.getList(),
      this.getStateList()
    ]);
  },
  methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getStateList() {
      try {
        let result = await Requests.getStateList();
        let tempStateList = result.data.data;
        for (var i = 0; i < tempStateList.length; i++) {
          this.statelist.push({
            'id': tempStateList[i].stateid,
            'label': tempStateList[i].statename.toUpperCase()
          })
        }
      } catch (err) {
        this.statelist = [];
      }
    },
    async getCityList(cityid) {
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await Requests.getCityList(inputPayload)
        return result.data.data;
      } catch (err) {
        this.citylist = [];
      }
    },
    selectCompanyName(data){
        this.selectedcompanyName = data;
        this.companyName = data.value;
    },
    async getCompanyShortName(){
      try {
        this.isLoading = true;
        let CompanyShortList = []
        let result = await Requests.getActiveInactiveClientList()
         CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.CompanyShortNameArr.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName
          });
        }
        this.isLoading = false
      } catch(err){
      }
    },
    format_date(value){
     if (value) {
        return moment(String(value)).format('DD-MM-YYYY hh:mm')
      }
    },
  async getList(){
      let payload = {
        "offset": this.offset,
        "limit": 10,
        "roleID" : this.userrole,
        "userID" : this.userid
      }
      if (isNaN(this.clientsystemID)) {
        this.$alert("Please Enter Client System ID In Number Format","Client","error");
        return true
      }
      if (isNaN(this.requestID)) {
        this.$alert("Please Enter Request ID In Number Format","Client","error");
        return true
      }
      if (this.clientsystemID) {
        payload.clientID = parseInt(this.clientsystemID);
      }
      if (this.requestID) {
        payload.requestID = this.requestID;
      }
      if (this.companyName) {
        payload.clientID = parseInt(this.companyName.value);
      }
      if (this.fromdate) {
        payload.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
        if (this.fromdate > this.todate) {
          this.$alert("From Date Must be Less Than To Date","Pending Requests","error");
          return true;
        }
      }

      if (this.todate) {
        payload.toDate = moment(this.todate).format('YYYY-MM-DD');
        if (this.fromdate > this.todate) {
          this.$alert("From Date Must be Less Than To Date","Pending Requests","error");
          return true;
        }
      }
      if (this.request) {
        payload.objectType = this.request;
      }

      this.isLoading = true;
      let result = await Requests.getCompletedApprovalRequest(payload);
      this.isLoading = false;

      if (result.data.code == 200) {
        let data = result.data.data.rows;
        this.pendingRequestsList = [];
        for (var i = 0; i < data.length; i++) {
          this.pendingRequestsList.push({
            'Company Short/Display Name' : (data[i].clientshortname != undefined) ? data[i].clientshortname : data[i].objectname,
            'Request ID': data[i].id,
            'Request For': `${data[i].objecttype} Approval`,
            'Request By':  data[i].createdby,
            'Request Date': Util.displayDateTimeFormat(data[i].createddate),
            'Request Status' : 'Accept',
            'Action Date' : Util.displayDateTimeFormat(data[i].lastmodifieddate),
            'Action By' : data[i].lastmodifiedby,
            'id' : (data[i].clientid != null) ? data[i].clientid : data[i].objectrecordid,
            'clientShortName' : data[i].clientshortname,
            'objectShortName' : data[i].objectname,
          })
        }
        this.totalrows = result.data.data.count
        if (this.totalrows < 10) {
          this.pageCount = 1
        } else {
          this.pageCount = Math.ceil(this.totalrows / 10);
        }
      }else {
        this.isLoading = false;
        this.$alert("Internal Server Error","Pending Requests","error");
      }
    },
  async onSubmitSearch(){
    if (this.request == '' && this.requestID == '' &&
       this.companyName == '' && this.clientsystemID == '' &&
       this.fromdate == '' && this.todate == '') {
        this.$alert("Please Select At List One Filed","Pending Requests","error");
      }else {
        this.currentPage = 1;
        this.totalrows = 0;
        this.offset = 0;
        this.getList();
      }
    },
    onPageChange(page) {
      this.currentPage = page;
       this.offset = (page - 1) *10;
      this.getList();
    },
    async getCustomTableEvent(event) {
      if (event.actionType == "view")  {
        this.viewFlag = true;
        let payload = {
          clientid : event.id
        }
        this.selectedViewRow = payload;
        this.selectBusinessAccId = event.id;
        this.viewFlag = false;
      }
    },
    clearForm(){
      this.request = 'client';
      this.requestID = '';
      this.companyName = '';
      this.clientsystemID = '';
      this.fromdate = '';
      this.todate = '';
      this.currentPage = 1;
      this.totalrows = 0;
      this.offset = 0;
      this.selectedcompanyName = {
        "value": '',
        "text": ''
      };
      this.getList();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/requests/views/approvalrequest/completedrequests/completedrequests.component.js